import { useQuery } from "@tanstack/react-query";
import { IContatosCobrancaRetorno } from "@/models/consignado/proposal-billings.model";
import { buscarContatosPorCcb } from "@/services/consignado/proposta-cobranca.service";

// Query de GET /proposta/cobrancas/:ccb/contatos (HIS-024), usada pela
// ContatosSection. A rota aceita número da CCB ou UUID; o redesign manda o
// número.
export const CONTATOS_CCB_QUERY_KEY = "contatos-cobranca";

export function useContatosPorCcb(numeroCcb: string, enabled = true) {
  return useQuery<IContatosCobrancaRetorno>({
    queryKey: [CONTATOS_CCB_QUERY_KEY, numeroCcb],
    queryFn: () => buscarContatosPorCcb(numeroCcb),
    enabled,
    retry: 0,
    refetchOnWindowFocus: false,
  });
}
